import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { MetricsBand } from './components/MetricsBand';
import { ExecutiveProfile } from './components/ExecutiveProfile';
import { AdvisoryServices } from './components/AdvisoryServices';
import { CareerTimeline } from './components/CareerTimeline';
import { ProjectPortfolio } from './components/ProjectPortfolio';
import { ExpertiseTags } from './components/ExpertiseTags';
import { SiteFooter } from './components/SiteFooter';
import { ContactModal } from './components/ContactModal';
export function App() {
  const [contactOpen, setContactOpen] = useState(false);
  const openContact = () => setContactOpen(true);
  return <div className="min-h-full w-full bg-white font-sans" data-id="element-0" data-mp="2wiferaffj2x4">
      <Navigation onRequestBriefing={openContact} data-id="element-1" data-mp="28tw62tsgwo4i" />
      <main data-id="element-2" data-mp="28sl4n0mhvsgk">
        <Hero onRequestBriefing={openContact} data-id="element-3" data-mp="28sbe9bxjfjac" />
        <MetricsBand data-id="element-4" data-mp="23w4clvc6cty7" />
        <ExecutiveProfile data-id="element-5" data-mp="23utbk3a460as" />
        <AdvisoryServices onRequestBriefing={openContact} data-id="element-6" data-mp="23ti8k5ohswkq" />
        <CareerTimeline data-id="element-7" data-mp="3ij64a9st9l7v" />
        <ProjectPortfolio data-id="element-8" data-mp="3ijpef4c7z5bc" />
        <ExpertiseTags data-id="element-9" data-mp="3mlj6wpc9h30f" />
      </main>
      <SiteFooter onRequestBriefing={openContact} data-id="element-10" data-mp="3mkho1yp07c85" />
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} data-id="element-11" data-mp="3mj6lu3b7icj5" />
    </div>;
}